import { AxiosService } from '../../../utils/AxiosService';
import Config from '../../../config';

const getUserPayments = async userId => await AxiosService.get(Config.server.api.paymentsApi + `admin/user/${userId}`, {}, true);
const getUserLicenses = async userId => await AxiosService.get(Config.server.api.paymentsApi + `admin/user/${userId}/licenses`, {}, true);
const createSuscription = async (userId, payload) => await AxiosService.post(Config.server.api.paymentsApi + `admin/user/${userId}/subscription`, payload, true);
const getUserSubscriptions = async userId => await AxiosService.get(Config.server.api.paymentsApi + `admin/user/${userId}/subscription`, {}, true);
const getProLicenses = async proUserId => await AxiosService.get(Config.server.api.paymentsApi + `admin/pro/${proUserId}/licenses`, {}, true);
// Historial anotado + licencia vigente + fecha de cobro que tiene puesta Stripe, en
// una sola llamada: es lo que permite ver el descuadre sin abrir Stripe.
const getProLicenseOverview = async proUserId => await AxiosService.get(Config.server.api.paymentsApi + `admin/pro/${proUserId}/license-overview`, {}, true);
const getProPlans = async () => await AxiosService.get(Config.server.api.paymentsApi + 'pro/plans', {}, true);
const getProPlanById = async planId => await AxiosService.get(Config.server.api.paymentsApi + `admin/pro/plan/${planId}`, {}, true);
const createProPlan = async payload => await AxiosService.post(Config.server.api.paymentsApi + 'admin/pro/plans', payload , true);
const updateProPlan = async (planId, payload) => await AxiosService.put(Config.server.api.paymentsApi + `admin/pro/plan/${planId}`, payload , true);
const deleteProPlan = async (planId) => await AxiosService.deleting(Config.server.api.paymentsApi + `admin/pro/plan/${planId}`, {} , true);
const createProPlanGeneralOffer = async payload => await AxiosService.post(Config.server.api.paymentsApi + 'admin/pro-plan/general-offer', payload , true);
const deleteProPlanGeneralOffer = async (offerId) => await AxiosService.deleting(Config.server.api.paymentsApi + `admin/pro-plan/general-offer/${offerId}`, {}, true);
const extendUserLicense = async (userId, payload) => await AxiosService.post(Config.server.api.paymentsApi + `admin/user/${userId}/licenses`, payload , true);
const extendProLicense = async (proUserId, payload) => await AxiosService.post(Config.server.api.paymentsApi + `admin/pro/${proUserId}/licenses`, payload , true);
const getPayments = async () => await AxiosService.get(Config.server.api.paymentsApi + `admin`, {}, true);
const getUserPaymentInvoice = async (userId, paymentId) => await AxiosService.getBlob(Config.server.api.paymentsApi + `admin/user/${ userId }/invoice/${ paymentId }`, true);
const getInvestements = async () => await AxiosService.get(Config.server.api.paymentsApi + `admin/ygb/investment`, {}, true);
const getCommissions = async type => await AxiosService.get(Config.server.api.paymentsApi + `commission/${type}`, {}, true);

export default {
    extendUserLicense,
    extendProLicense,
    getUserLicenses,
    getProLicenses,
    getProLicenseOverview,
    getPayments,
    getUserPayments,
    getUserPaymentInvoice,
    getInvestements,
    getCommissions,
    createSuscription,
    getUserSubscriptions,
    getProPlans,
    getProPlanById,
    createProPlan,
    updateProPlan,
    deleteProPlan,
    createProPlanGeneralOffer,
    deleteProPlanGeneralOffer
}